<template>
    <slot :loading="loading" :events="events"></slot>
</template>

<script>
'use strict'

import { defineComponent, ref } from 'vue';
import { format } from 'date-fns';
import zonedDate from '../utils/zoned-date';
import { getPerformances } from '../services/inventory';

export default defineComponent({
    name: 'EventInstances',
    props: {
        productionSeasonIds: {
            type: Array,
        },
        productionPerformances: {
            type: Array,
        },
        domain: {
            type: String,
        },
    },

    setup(props) {
        const events = ref([]);
        const loading = ref(true);

        getPerformances()
            .then((instances) => {
                // Filter out events that are not in the production season IDs
                events.value = instances.filter((event) => {
                    if (props.productionPerformances && props.productionPerformances.length) {
                        // Filter by performance IDs if provided
                        return props.productionPerformances.includes(parseInt(event.tessitura.performanceId, 10));
                    }
                    // Otherwise, filter by production season IDs
                    return props.productionSeasonIds.includes(parseInt(event?.tessitura?.productionSeasonId, 10))
                })
                    .map(event => {
                        const startDate = zonedDate(event.startDateLocalAsUTC);

                        return {
                            formattedDate: format(startDate, 'EEE, MMM dd, yyyy'),
                            formattedTime: format(startDate, 'hh:mm a'),
                            availability: event.availability,
                            availability_handle: event.availability_handle,
                            ctaPrimary: event.ctaPrimary,
                            datetime: format(startDate, 'yyyy-MM-dd HH:mm'),
                            tags: event.tags,
                        }
                    });
            })
            .finally(() => {
                loading.value = false;
            });

        return {
            events,
            loading,
        };
    },
});
</script>
